import * as React from 'react';
import { FC, useState, useCallback } from 'react';
import { ColorResult, RGBColor, SketchPicker } from 'react-color';
import { Box, Button } from '@mui/material';

interface ColorPickerProps {
  label?: string;
  defaultValue?: string;
  onChange?: (color: string) => void;
}

const ColorPicker: FC<ColorPickerProps> = ({ label, defaultValue = '#000000', onChange }) => {
  const isValidColor = /^#[0-9A-F]{6}$/i.test(defaultValue);
  const initialColor = isValidColor ? defaultValue : '#000000';

  const [color, setColor] = useState<RGBColor>({ r: 0, g: 0, b: 0, a: 1 });
  const [colorHex, setColorHex] = useState<string>(initialColor);
  const [displayColorPicker, setDisplayColorPicker] = useState<boolean>(false);

  const handleColorChange = useCallback((newColor: ColorResult) => {
    setColor(newColor.rgb);
    setColorHex(newColor.hex);
  }, []);

  const handleButtonClick = useCallback(() => {
    setDisplayColorPicker((prev) => !prev);
  }, []);

  const handlePickerClose = useCallback(() => {
    setDisplayColorPicker(false);
    if (onChange && colorHex) {
      onChange(colorHex);
    }
  }, [onChange, colorHex]);

  return (
    <>
      <Button
        variant="contained"
        component="label"
        onClick={handleButtonClick}
        sx={{ backgroundColor: colorHex, color: '#ffffff' }}
      >
        {label || colorHex}
      </Button>
      {displayColorPicker && (
        <Box sx={{ position: 'absolute', zIndex: 2 }}>
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              border: '1px solid #000',
              borderRadius: '40px',
            }}
            onClick={handlePickerClose}
          />
          <SketchPicker
            color={color}
            onChange={handleColorChange}
          />
        </Box>
      )}
    </>
  );
};

export default ColorPicker;
